(function () {

  var BASE = 'https://fiorena.it/cdn/shop/files/';

  var ICONE_ORO = {
    'Cuore Rosso':  BASE + 'Cuore_-Rosso.png',
    'Cuore Rosa':   BASE + 'cuore_rosa.png',
    'Gennaio':      BASE + 'gennaio.png',
    'Febbraio':     BASE + 'febbraio.png',
    'Marzo':        BASE + 'marzo.png',
    'Aprile':       BASE + 'aprile.png',
    'Maggio':       BASE + 'maggio.png',
    'Giugno':       BASE + 'giugno.png',
    'Luglio':       BASE + 'luglio.png',
    'Agosto':       BASE + 'agosto.png',
    'Settembre':    BASE + 'settembre.png',
    'Ottobre':      BASE + 'ottobre.png',
    'Novembre':     BASE + 'novembre.png',
    'Dicembre':     BASE + 'dicembre.png',
    'Ariete':       BASE + 'ariete.png',
    'Toro':         BASE + 'Toro.png',
    'Gemelli':      BASE + 'gemeli.png',
    'Cancro':       BASE + 'cancro.png',
    'Leone':        BASE + 'leone.png',
    'Vergine':      BASE + 'vergine.png',
    'Bilancia':     BASE + 'bilancia.png',
    'Scorpione':    BASE + 'scorpione.png',
    'Sagittario':   BASE + 'sagittario.png',
    'Capricorno':   BASE + 'capricorno.png',
    'Acquario':     BASE + 'acquario.png',
    'Pesci':        BASE + 'pesci.png',
  };

  var ICONE_ARGENTO = {
    'Cuore Rosso':  BASE + 'cuore_rosso_silver.png',
    'Cuore Rosa':   BASE + 'cuore_rosa_silver.png',
    'Gennaio':      BASE + 'gennaio.png',
    'Febbraio':     BASE + 'febbraio.png',
    'Marzo':        BASE + 'marzo.png',
    'Aprile':       BASE + 'aprile.png',
    'Maggio':       BASE + 'maggio.png',
    'Giugno':       BASE + 'giugno.png',
    'Luglio':       BASE + 'luglio.png',
    'Agosto':       BASE + 'agosto.png',
    'Settembre':    BASE + 'settembre.png',
    'Ottobre':      BASE + 'ottobre.png',
    'Novembre':     BASE + 'novembre.png',
    'Dicembre':     BASE + 'dicembre.png',
    'Ariete':       BASE + 'ariete_silver.png',
    'Toro':         BASE + 'Toro_silver.png',
    'Gemelli':      BASE + 'gemeli_silver.png',
    'Cancro':       BASE + 'cancro_silver.png',
    'Leone':        BASE + 'leone_silver.png',
    'Vergine':      BASE + 'vergine_silver.png',
    'Bilancia':     BASE + 'bilancia_silver.png',
    'Scorpione':    BASE + 'scorpione_silver.png',
    'Sagittario':   BASE + 'sagittario_silver.png',
    'Capricorno':   BASE + 'capricorno_silver.png',
    'Acquario':     BASE + 'acquario_silver.png',
    'Pesci':        BASE + 'pesci_silver.png',
  };

  var coloreAttivo = 'oro';
  var numeroAttivo = 4;

  document.querySelectorAll('.cs-colore-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      document.querySelectorAll('.cs-colore-btn').forEach(function(b) { b.classList.remove('attivo'); });
      this.classList.add('attivo');
      var val = this.dataset.colore;
      coloreAttivo = val.toLowerCase().includes('argento') ? 'argento' : 'oro';
      document.getElementById('cs-colore-testo').textContent = val;
      document.getElementById('cs-colore-nascosto').value = val;
      aggiornaAnteprima();
    });
  });

  document.querySelectorAll('.cs-num-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      document.querySelectorAll('.cs-num-btn').forEach(function(b) { b.classList.remove('attivo'); });
      this.classList.add('attivo');
      numeroAttivo = parseInt(this.dataset.numero);
      document.getElementById('cs-numero-testo').textContent = numeroAttivo;
      document.getElementById('cs-numero-nascosto').value = numeroAttivo;
      aggiornaRighe();
      aggiornaAnteprima();
    });
  });

  function aggiornaRighe() {
    document.querySelectorAll('.cs-riga-scelta').forEach(function(riga) {
      var slot = parseInt(riga.dataset.slot);
      riga.style.display = slot <= numeroAttivo ? 'flex' : 'none';
      if (slot > numeroAttivo) {
        var sel = riga.querySelector('select');
        if (sel) sel.value = '';
      }
    });
  }

  function getUrl(valore, argento) {
    var map = argento ? ICONE_ARGENTO : ICONE_ORO;
    return map[valore] || null;
  }

  function creaSlot(valore, argento) {
    var url = getUrl(valore, argento);

    if (url) {
      var img = document.createElement('img');
      img.src = url;
      img.alt = valore;
      img.className = 'cs-preview-img';
      return img;
    }

    if (valore && valore.startsWith('Iniziale - ')) {
      var letter = valore.replace('Iniziale - ', '');
      var wrap = document.createElement('div');
      wrap.className = 'cs-iniziale-wrap' + (argento ? ' argento' : '');
      var span = document.createElement('span');
      span.className = 'cs-iniziale-letter';
      span.textContent = letter;
      wrap.appendChild(span);
      return wrap;
    }

    var fallback = document.createElement('div');
    fallback.style.cssText = 'width:46px;height:46px;display:flex;align-items:center;justify-content:center;font-size:12px;color:#aaa;flex-shrink:0;';
    fallback.textContent = '?';
    return fallback;
  }

  function aggiornaAnteprima() {
    var cont = document.getElementById('cs-anteprima-icone');
    var vuoto = document.getElementById('cs-anteprima-vuota');
    if (!cont) return;

    var argento = coloreAttivo === 'argento';
    var valori = [];
    for (var i = 1; i <= 4; i++) {
      var sel = document.getElementById('cs-select-' + i);
      valori.push(sel ? sel.value : '');
    }

    var gevuld = valori.slice(0, numeroAttivo).filter(function(v) { return v !== ''; });
    cont.innerHTML = '';

    if (gevuld.length === 0) {
      if (vuoto) vuoto.style.display = 'block';
      return;
    }
    if (vuoto) vuoto.style.display = 'none';

    for (var i = 0; i < gevuld.length; i++) {
      cont.appendChild(creaSlot(gevuld[i], argento));
    }
  }

  document.addEventListener('change', function(e) {
    if (e.target.classList.contains('cs-select')) {
      aggiornaAnteprima();
      if (e.target.value !== '') {
        e.target.style.borderColor = '#e0e0e0';
      }
      var fout = document.getElementById('cs-fout-melding');
      if (fout) {
        var alleIngevuld = true;
        for (var i = 1; i <= numeroAttivo; i++) {
          var sel = document.getElementById('cs-select-' + i);
          if (sel && sel.value === '') {
            alleIngevuld = false;
          }
        }
        if (alleIngevuld) fout.style.display = 'none';
      }
    }
  });

  var reset = document.getElementById('cs-reset');
  if (reset) {
    reset.addEventListener('click', function() {
      for (var i = 1; i <= 4; i++) {
        var sel = document.getElementById('cs-select-' + i);
        if (sel) {
          sel.value = '';
          sel.style.borderColor = '#e0e0e0';
        }
      }
      var fout = document.getElementById('cs-fout-melding');
      if (fout) fout.style.display = 'none';
      aggiornaAnteprima();
    });
  }

  function valideer() {
    var selettore = document.getElementById('cs-selettore');
    if (!selettore) return true;

    var aantalVereist = numeroAttivo;
    var aantalIngevuld = 0;
    var eersteLeeg = null;

    for (var i = 1; i <= aantalVereist; i++) {
      var sel = document.getElementById('cs-select-' + i);
      if (sel) {
        if (sel.value === '') {
          if (!eersteLeeg) eersteLeeg = sel;
          sel.style.borderColor = '#e53e3e';
        } else {
          aantalIngevuld++;
          sel.style.borderColor = '#e0e0e0';
        }
      }
    }

    if (aantalIngevuld < aantalVereist) {
      if (eersteLeeg) {
        eersteLeeg.scrollIntoView({ behavior: 'smooth', block: 'center' });
        eersteLeeg.focus();
      }

      var fout = document.getElementById('cs-fout-melding');
      if (!fout) {
        fout = document.createElement('p');
        fout.id = 'cs-fout-melding';
        fout.style.cssText = 'color:#e53e3e;font-size:13px;text-align:center;margin-top:8px;font-weight:500;';
        var resetBtn = document.getElementById('cs-reset');
        if (resetBtn) {
          resetBtn.parentNode.insertBefore(fout, resetBtn.nextSibling);
        }
      }
      fout.textContent = 'Per favore completa tutte le ' + aantalVereist + ' scelte prima di aggiungere al carrello.';
      fout.style.display = 'block';
      return false;
    }

    var fout = document.getElementById('cs-fout-melding');
    if (fout) fout.style.display = 'none';
    return true;
  }

  document.addEventListener('click', function(e) {
    var selettore = document.getElementById('cs-selettore');
    if (!selettore) return;

    var btn = e.target.closest('button[name="add"], button[type="submit"], .add-to-cart, #AddToCart, .btn-add-to-cart, [data-add-to-cart]');
    if (btn) {
      if (!valideer()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
      }
    }
  }, true);

  document.addEventListener('submit', function(e) {
    var selettore = document.getElementById('cs-selettore');
    if (!selettore) return;

    if (!valideer()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return false;
    }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      aggiornaRighe();
      aggiornaAnteprima();
    });
  } else {
    aggiornaRighe();
    aggiornaAnteprima();
  }

})();